export const commonInitialBenefitState = {
  title: '',
  content: '',
  image: null,
};
